const generateBrochureLink = (brochureId, travelAgency) => {
  if (!brochureId || !travelAgency?.agencyAliasName) {
    return null;
  }

  const alias = travelAgency.agencyAliasName;
  const path = `/${alias}/brochure`;
  const url = new URL(path, window.location.origin);
  url.searchParams.set('id', brochureId);

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('test') === 'true') url.searchParams.set('test', 'true');

  return url.toString();
};

export default generateBrochureLink;
